import { Link } from "react-router-dom";

export default function SubscriptionPromo({ compact = false }) {
  return (
    <section className={"subscription-promo" + (compact ? " compact" : "")} data-testid="subscription-promo">
      <div>
        <p className="eyebrow">TAILOR INC. PREFERRED SUBSCRIPTION</p>
        <h2>Better fitting clothes.<br /><em>Better value.</em></h2>
        <p className="intro">Enjoy preferred access to personal tailoring for just <strong>$29.99 per month.</strong></p>
        <ul className="ticks">
          <li>2 eligible QuickFit alterations per calendar quarter</li>
          <li>10% off eligible additional alteration labor</li>
          <li>Priority scheduling</li>
          <li>Exclusive rotating quarterly offers</li>
        </ul>
        <Link to="/subscription" className="button gold" data-testid="promo-explore-btn">Explore the Subscription</Link>
      </div>
      <div className="savings">
        <p className="eyebrow">WHAT SAVINGS COULD LOOK LIKE</p>
        <div className="mathline"><span>Example alteration work</span><strong>$210</strong></div>
        <div className="mathline"><span>Qualifying QuickFit benefit</span><strong>−$30</strong></div>
        <div className="mathline"><span>10% off remaining $180</span><strong>−$18</strong></div>
        <div className="mathline total"><span>Example alteration total</span><strong>$162</strong></div>
        <p className="bigsave">$48 <span>illustrative alteration savings</span></p>
        <p className="fine">Illustrative only, assuming an available eligible $30 QuickFit service and 10% discount on separate eligible labor. $29.99 subscription charge and fitting reservation are additional. Benefits and discounts are subject to plan terms and eligibility.</p>
      </div>
    </section>
  );
}
